import React from 'react';
import { motion } from 'framer-motion';
import { Search, Bot, Zap } from 'lucide-react';

const STEPS = [
  {
    icon: Search,
    title: 'We map your workflows',
    body: '30-minute call to find where your time actually goes — invoicing, follow-up, outreach, reviews. We pick the highest-ROI tasks to automate first.',
  },
  {
    icon: Bot,
    title: 'I build the agents',
    body: 'Custom AI systems designed around your business — not a template you configure. Every automation works the way you already work.',
  },
  {
    icon: Zap,
    title: 'They run themselves',
    body: 'Live 24/7 from day one. When something needs your attention, it finds you. Everything else happens in the background — no babysitting required.',
  },
];

function Process() {
  return (
    <section id="process" className="relative py-24">
      <div className="max-w-7xl mx-auto px-6">
        <div className="max-w-2xl mx-auto text-center mb-14">
          <p className="text-sm text-accent-2 font-medium mb-3 uppercase tracking-wider">How it works</p>
          <h2 className="font-display font-bold text-3xl md:text-4xl text-text mb-4">
            From conversation to automation{' '}
            <span className="gradient-text">in days.</span>
          </h2>
          <p className="text-text-muted text-lg">
            Most businesses have their first agent running within a week of our initial call.
          </p>
        </div>

        <div className="relative grid md:grid-cols-3 gap-6">
          <div className="hidden md:block absolute top-8 left-[16%] right-[16%] h-px bg-gradient-to-r from-transparent via-accent/40 to-transparent" />

          {STEPS.map((s, i) => (
            <motion.div
              key={s.title}
              initial={{ opacity: 0, y: 12 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '0px 0px 300px 0px' }}
              transition={{ duration: 0.3, delay: i * 0.06 }}
              className="relative text-center"
            >
              <div className="relative inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-gradient-brand mb-5 shadow-glow">
                <s.icon size={26} className="text-white" />
                <span className="absolute -top-2 -right-2 w-6 h-6 rounded-full bg-bg border border-accent/40 text-xs text-accent-2 font-semibold flex items-center justify-center">
                  {i + 1}
                </span>
              </div>
              <h3 className="font-display font-semibold text-xl text-text mb-2">{s.title}</h3>
              <p className="text-text-muted text-sm max-w-xs mx-auto leading-relaxed">{s.body}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Process;
